import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.scss';
import ScrollToTop from "./ScrollToTop";

import App from './App';

import FrontPage from './pages/FrontPage';
import DemoReel from './pages/DemoReel';
import VisDev from './pages/VisDev';
import About from './pages/About';
import Contact from './pages/Contact';
import Ndawork from './pages/Ndawork';
import Illustration from './pages/Illustration';
import Sketches from './pages/Sketches';

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <App>
      <Switch>
        <Route path="/" exact component={FrontPage}/>
        <Route path="/demo-reel" exact component={DemoReel}/>
        <Route path="/visdev" exact component={VisDev}/>
        <Route path="/about" exact component={About}/>
        <Route path="/contact" exact component={Contact}/>
        <Route path="/illustration" exact component={Illustration}/>
        <Route path="/ndawork" exact component={Ndawork}/>
        <Route path="/sketches" exact component={Sketches}/>
      </Switch>
    </App>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
